import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

var API = "/api";

var AuthContext = createContext();

export function AuthProvider({ children }) {
  var [user, setUser] = useState(null);
  var [isLoading, setIsLoading] = useState(true);

  // Check auth status on mount - relies on httpOnly cookie
  var checkAuth = useCallback(function() {
    return axios.get(API + "/auth/me", { withCredentials: true })
      .then(function(res) { 
        setUser(res.data); 
        return res.data;
      })
      .catch(function() { 
        setUser(null);
        return null;
      })
      .finally(function() { setIsLoading(false); });
  }, []);

  useEffect(function() {
    checkAuth();
  }, [checkAuth]);

  var login = useCallback(function(email, password) {
    return axios.post(API + "/auth/login", { email: email, password: password }, { withCredentials: true })
      .then(function(res) {
        setUser(res.data.user);
        return res.data;
      });
  }, []);

  var register = useCallback(function(name, email, password) {
    return axios.post(API + "/auth/register", { name: name, email: email, password: password }, { withCredentials: true })
      .then(function(res) {
        setUser(res.data.user);
        return res.data;
      });
  }, []);

  var loginWithGoogle = useCallback(function() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    var redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  }, []);

  var processGoogleCallback = useCallback(function(sessionId) {
    return axios.post(API + "/auth/google/session", { session_id: sessionId }, { withCredentials: true })
      .then(function(res) {
        setUser(res.data.user);
        return res.data;
      });
  }, []);

  var logout = useCallback(function() {
    return axios.post(API + "/auth/logout", {}, { withCredentials: true })
      .finally(function() {
        setUser(null);
      });
  }, []);

  var value = {
    user: user,
    isLoading: isLoading,
    isAuthenticated: !!user,
    login: login,
    register: register,
    loginWithGoogle: loginWithGoogle,
    processGoogleCallback: processGoogleCallback,
    logout: logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  var context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
}
